<template>
    <div class="kd-sidemenu">
        <div class="sidemenu-wrapper">
            <div class="side-menu-group">
                <el-menu
                        :router="true"
                        :collapse="isCollapse"
                        :default-active="activeNav"
                        :unique-opened="true"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose"
                        background-color="transparent"
                        text-color="#fff"
                        active-text-color="#fff">
                    <div v-for="(item, findex) in menuData.menus" :key="findex">
                        <!-- <el-submenu v-if="item.menus && item.menus.length > 0" :index="findex+''">
                            <template slot="title">
                                <i class="iconfont" :class="item.iconClass"></i>
                                <span>{{item.menuName}}</span>
                            </template>
                            <el-menu-item-group v-if="item.menus && item.menus.length >  0 "
                                                v-for="(secNav, sindex) in item.menus" :key="sindex">
                                <el-submenu :index="secNav.menuPath" v-if="secNav.menus && secNav.menus.length > 0">
                                    <template slot="title">{{secNav.menuName}}</template>
                                    <el-menu-item :index="thirdNav.menuPath" v-for="(thirdNav, tindex) in secNav.menus"
                                                  :key="tindex">{{thirdNav.menuName}}
                                    </el-menu-item>
                                </el-submenu>
                                <el-menu-item v-else :index="secNav.menuPath">{{secNav.menuName}}</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu> -->
                        <el-menu-item class="el-menu-single" v-if="item.menus && item.menus.length === 0 "
                                      :index="item.menuPath" :key="findex">
                            <span><i class="iconfont" :class="item.iconClass"></i></span>
                            <span>{{item.menuName}}</span>
                        </el-menu-item>
                    </div>
                </el-menu>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
		props: {
			isCollapse: {
				type: Boolean,
				default: false
			},
			menuData: {
				type: Object,
				default: {
					menus: []
				}
			}
		},
		data() {
			return {
				activeNav: '/icmp'
			};
		},
		created() {
		},
		mounted() {
			this.setHight();
		},
		methods: {
			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			},
			setHight() {
				let path = this.$route.path;
				// 处理二级路由菜单不高亮
				if (path.indexOf('deploy-photos') > -1) {
					path = '/icmp/deploy-store';
				}
				if (path.indexOf('grid-manage') > -1) {
					path = '/icmp/grid-manage';
				}
				this.activeNav = path;
			}
		},
		watch: {
			$route: {
				handler(val) {
					this.setHight();
				},
				deep: true
			}
		},
		computed: {}
	};
</script>

<style lang="scss" scoped>
    .kd-sidemenu {
    }

    .sidemenu-wrapper {
        padding: 0;
        .side-header {

        }
        .side-menu-group {
            height: calc(100vh - 120px - 50px);
            overflow-y: auto;
            overflow-x: hidden;
			.el-menu {
				border: none;
				.el-menu-item {
					height: 80px;
					line-height: normal;
					padding: 16px 10px;
					padding-left: 10px!important;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					border-left: 2px solid #fff;
					span {
						font-size: 14px;
						color: #333;
						height: 20px;
						i {
							color: #333;
							font-size: 24px;
						}
						&:first-child {
							margin-bottom: 10px;
						}
					}
					&:hover, &.is-active {
						background-color: #f0f8ff!important;
						border-left: 2px solid #3860f4;
						span {
							color: #3860f4;
							i {
								color: #3860f4;
							}
						}
					}
				}
			}
        }
        .side-version-info {
            font-size: 12px;
            color: #999;
            text-align: center;
        }
    }

    /*滚动条样式*/
    .side-menu-group::-webkit-scrollbar { /*滚动条整体样式*/
        width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
    }

    .side-menu-group::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px #00000099;
        background: rgba(0, 0, 0, 0.5);
    }

    .side-menu-group::-webkit-scrollbar-track { /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.1);
    }
    .nav-hide {
        .sidemenu-wrapper {
            .side-menu-group {
                height: calc(100vh - 50px);
                overflow-y: auto;
                overflow-x: hidden;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// components/kd-sidemenu/kd-sidemenu.vue